import { TextArea } from "devextreme-react";
import { DESIGN_ITEM_CATEGORY3 } from "@constants/inbound";
import { useAtomValue } from "jotai";
import { hcostInboundAtom } from "@/store/hcost-atom";
import { counselDesignItemCategory1, counselDesignItemCategory2 } from "@constants/inbound-const";

type Props = {
  selectedIndex: number;
};

type CounselDesignItemSummary = {
  [key: string]: CounselDesignItem[];
};
const CounselSummary = ({ selectedIndex }: Props) => {
  const hCostResult = useAtomValue(hcostInboundAtom);
  const makeDataFacilityDetailGroup = (data: CounselDesignItem[]) => {
    if (!data) return;
    let result: CounselDesignItemSummary;
    result = data.reduce((prev: CounselDesignItemSummary, cur: CounselDesignItem) => {
      if (cur.enabled) {
        const category = cur.category1.code;
        if (prev[category]) prev[category].push(cur);
        else prev[category] = [cur];
      }
      return prev;
    }, {});
    return result;
  };

  const makeStringDataFacilityDetail = (data: CounselDesignItemSummary) => {
    if (data) {
      const stringData = [...Object.entries(data)].sort().map((v: any) => {
        let value: string[] = [];
        let category2: string[] = [];
        v[1].map((item: any) => {
          value.push(item.category2.code);
        });
        const deduplicate = value.filter((c: string, index: number) => value.indexOf(c) === index);
        deduplicate.map((v: string) => {
          if (v !== DESIGN_ITEM_CATEGORY3.NOTHING) {
            category2.push(counselDesignItemCategory2[v]);
          }
        });
        return ` \n${counselDesignItemCategory1[v[0]]} \n - ${category2} \n`;
      });
      return stringData.join("");
    }
  };

  const conDateFormat = (): string => {
    if (!hCostResult.conDate) return "";

    const date = new Date(hCostResult.conDate);

    return `${date.getFullYear()}년 ${date.getMonth() + 1}월`;
  };

  const makeData: string =
    `- 신청번호 : ${hCostResult.id}` +
    `\n- 고객명 : ${hCostResult.customerName ? hCostResult.customerName : ""}` +
    `\n- 연락처 : ${hCostResult.customerPhone ? hCostResult.customerPhone : ""}` +
    `\n- 시공예정일 : ${hCostResult.conDate ? conDateFormat() : ""}` +
    `\n- 시공지주소 : ${hCostResult.conAddress ? hCostResult.conAddress : ""} ${
      hCostResult.conAddressDetail ? hCostResult.conAddressDetail : ""
    }` +
    `\n- 토지소유 : ${hCostResult.conLandOwnershipType ? hCostResult.conLandOwnershipType : ""}` +
    `\n- 정부사업 : ${
      hCostResult.conSupportType
        ? `${hCostResult.conSupportType} ${hCostResult.conSupportName ? `(${hCostResult.conSupportName})` : ""}`
        : ""
    }` +
    `\n- 최대예산 : ${hCostResult.conBudget ? hCostResult.conBudget.toLocaleString() : ""}` +
    `\n- 요청사항 : ${hCostResult.counselMemo ? hCostResult.counselMemo : ""}` +
    `\n- 거래방식 : ${hCostResult.transactionMethod ? hCostResult.transactionMethod.value : ""}` +
    `\n\n기본정보` +
    `\n- 용도/작물 :  ${hCostResult.conUsage ? hCostResult.conUsage : ""}` +
    `\n- 시설유형 : ${
      hCostResult.counselDesigns[selectedIndex].facilityType
        ? hCostResult.counselDesigns[selectedIndex].facilityType.value
        : ""
    }, ${
      hCostResult.counselDesigns[selectedIndex].counselDesignBasic.level
        ? hCostResult.counselDesigns[selectedIndex].counselDesignBasic.level
        : "?"
    }중` +
    `\n- 시설면적 : ${
      hCostResult.counselDesigns[selectedIndex].counselDesignBasic.areaPyeong
        ? Intl.NumberFormat("ko-KR").format(hCostResult.counselDesigns[selectedIndex].counselDesignBasic.areaPyeong) +
          "평"
        : ""
    }` +
    `\n- 시설규격 : 한동 폭${
      hCostResult.counselDesigns[selectedIndex].counselDesignBasic.widthBay
        ? Intl.NumberFormat("ko-KR").format(hCostResult.counselDesigns[selectedIndex].counselDesignBasic.widthBay) +
          `m(${hCostResult.counselDesigns[selectedIndex].counselDesignBasic.width}m) x `
        : ""
    }길이${
      hCostResult.counselDesigns[selectedIndex].counselDesignBasic.length
        ? Intl.NumberFormat("ko-KR").format(hCostResult.counselDesigns[selectedIndex].counselDesignBasic.length) + "m x"
        : ""
    } ${
      hCostResult.counselDesigns[selectedIndex].counselDesignBasic.bay
        ? Intl.NumberFormat("ko-KR").format(hCostResult.counselDesigns[selectedIndex].counselDesignBasic.bay) + "동"
        : ""
    }, 측고${
      hCostResult.counselDesigns[selectedIndex].counselDesignBasic.heightSide
        ? Intl.NumberFormat("ko-KR").format(hCostResult.counselDesigns[selectedIndex].counselDesignBasic.heightSide) +
          "m"
        : ""
    }` +
    `\n- 토지규격 : ${
      hCostResult.counselDesigns[selectedIndex].counselDesignBasic.landWidth
        ? "폭" +
          Intl.NumberFormat("ko-KR").format(hCostResult.counselDesigns[selectedIndex].counselDesignBasic.landWidth) +
          "m x "
        : ""
    }${
      hCostResult.counselDesigns[selectedIndex].counselDesignBasic.landLength
        ? "길이" +
          Intl.NumberFormat("ko-KR").format(hCostResult.counselDesigns[selectedIndex].counselDesignBasic.landLength) +
          "m"
        : ""
    }${
      hCostResult.counselDesigns[selectedIndex].counselDesignBasic.landPyeong
        ? " = " +
          Intl.NumberFormat("ko-KR").format(hCostResult.counselDesigns[selectedIndex].counselDesignBasic.landPyeong) +
          "평"
        : ""
    }` +
    `\n${
      !!hCostResult.counselDesigns[selectedIndex].counselDesignItems
        ? `${makeStringDataFacilityDetail(
            makeDataFacilityDetailGroup(hCostResult.counselDesigns[selectedIndex].counselDesignItems),
          )}`
        : ""
    }`;
  return (
    <>
      {/*요약 정보*/}
      <TextArea value={makeData} readOnly height={300} />
    </>
  );
};

export default CounselSummary;
